export default __webpack_public_path__ + "static/media/noun-client.d5dd3aea.svg";